export default __webpack_public_path__ + "static/question-frame-be1f8461637bb652dfe813c02b47022f.png";